var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWzchatbot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chatbot (3) 1",
    clipPath: "url(#clip0_2427_2802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81152 -0.034668C12.2477 -0.034668 22.6839 -0.034668 33.1201 -0.034668C34.0771 0.23877 34.6924 0.854004 34.9658 1.81104C34.9658 3.20101 34.9658 4.59099 34.9658 5.98096C29.0185 5.99235 23.0712 5.98096 17.124 5.94678C16.643 5.78485 16.3582 5.45445 16.2695 4.95557C16.2468 4.36312 16.2239 3.77067 16.2012 3.17822C16.0194 2.76863 15.7118 2.50658 15.2783 2.39209C10.1742 2.35791 5.07004 2.34651 -0.0341797 2.35791C-0.0341797 2.17562 -0.0341797 1.99333 -0.0341797 1.81104C0.239258 0.854004 0.854492 0.23877 1.81152 -0.034668Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.0341797 2.35779C5.07004 2.34639 10.1742 2.35779 15.2783 2.39197C15.7118 2.50646 16.0194 2.76851 16.2012 3.1781C16.2239 3.77055 16.2468 4.363 16.2695 4.95545C16.3582 5.45433 16.643 5.78473 17.124 5.94666C23.0712 5.98084 29.0185 5.99223 34.9658 5.98084C34.9658 6.80115 34.9658 7.62146 34.9658 8.44177C23.2991 8.44177 11.6325 8.44177 -0.0341797 8.44177C-0.0341797 6.41378 -0.0341797 4.38579 -0.0341797 2.35779Z",
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3521 2.35791C26.9342 2.38142 27.1735 2.67764 27.0699 3.24658C26.8795 3.52966 26.6175 3.6322 26.2838 3.5542C25.9656 3.35619 25.863 3.07136 25.9762 2.69971C26.0944 2.56969 26.2197 2.45576 26.3521 2.35791Z",
    fill: "#23A1F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7446 2.35791C29.4494 2.40135 29.6659 2.74315 29.3941 3.3833C28.9715 3.70713 28.6297 3.63877 28.3687 3.17822C28.2916 2.80834 28.417 2.5349 28.7446 2.35791Z",
    fill: "#42C98D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2061 2.35791C31.8166 2.41792 32.033 2.73693 31.8555 3.31494C31.3106 3.75517 30.9347 3.64124 30.7275 2.97314C30.7746 2.67119 30.9341 2.46611 31.2061 2.35791Z",
    fill: "#DF4C3E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4074 4.20346C12.7494 4.1751 13.0342 4.28903 13.2619 4.54526C13.6002 4.1161 13.9648 4.09331 14.3556 4.4769C14.5116 4.83931 14.4319 5.14693 14.1163 5.39975C14.5385 5.74366 14.5613 6.10824 14.1847 6.4935C13.8031 6.67006 13.4842 6.59031 13.2277 6.25424C12.92 6.64813 12.5668 6.69369 12.1681 6.39096C11.9941 6.01596 12.051 5.68556 12.339 5.39975C11.954 4.96578 11.9768 4.56701 12.4074 4.20346Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69977 4.81873C5.09246 4.80733 7.48507 4.81873 9.87751 4.85291C10.2417 5.0878 10.31 5.39542 10.0826 5.77576C10.0142 5.83272 9.94587 5.88969 9.87751 5.94666C7.48493 5.99223 5.09235 5.99223 2.69977 5.94666C2.24851 5.57096 2.24851 5.19498 2.69977 4.81873Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.0341797 8.44189C11.6325 8.44189 23.2991 8.44189 34.9658 8.44189C34.9658 15.4601 34.9658 22.4783 34.9658 29.4966C34.6149 30.6764 33.8173 31.303 32.5732 31.3765C27.9476 31.4106 23.322 31.4221 18.6963 31.4106C18.9878 29.6051 18.4181 28.1582 16.9873 27.0698C16.4835 26.794 15.9594 26.6003 15.415 26.4888C18.2794 26.1293 19.9655 24.5342 20.4736 21.7036C21.2712 21.7036 22.0687 21.7036 22.8662 21.7036C22.8662 22.091 22.8662 22.4783 22.8662 22.8657C22.8549 23.322 22.8662 23.7778 22.9004 24.2329C22.9955 24.5138 23.1892 24.6733 23.4814 24.7114C23.7343 24.6647 23.9621 24.5622 24.165 24.4038C24.8657 23.8835 25.5493 23.348 26.2158 22.7974C26.7121 22.4838 27.1906 22.142 27.6514 21.772C28.7628 21.716 29.8794 21.6818 31.001 21.6694C31.8327 21.4758 32.3454 20.9631 32.5391 20.1313C32.5847 17.5109 32.5847 14.8904 32.5391 12.27C32.3436 11.5276 31.8765 11.0605 31.1377 10.8687C27.374 10.8012 23.6142 10.8239 19.8584 10.937C19.3169 11.1821 18.9409 11.581 18.7305 12.1333C18.6963 13.3636 18.6849 14.594 18.6963 15.8247C17.9687 15.1875 17.1257 14.766 16.167 14.5601C14.5396 14.4832 12.9104 14.449 11.2793 14.4575C9.83233 14.4689 8.38544 14.4803 6.93848 14.4917C3.87131 15.281 2.34462 17.2634 2.3584 20.439C2.30729 23.6221 3.81119 25.6273 6.87012 26.4546C7.02803 26.4886 7.18751 26.4999 7.34863 26.4888C5.72855 26.844 4.69176 27.8238 4.23828 29.4282C4.22514 30.0943 4.19096 30.7551 4.13574 31.4106C3.26257 31.4463 2.39668 31.3894 1.53809 31.2397C0.709488 30.9243 0.185398 30.3432 -0.0341797 29.4966C-0.0341797 22.4783 -0.0341797 15.4601 -0.0341797 8.44189Z",
    fill: "#F1D9FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6517 21.7722C27.4365 21.7267 27.2086 21.704 26.9681 21.7038C26.2057 21.544 25.8753 21.8403 25.9769 22.5925C26.048 22.6752 26.1277 22.7436 26.2162 22.7976C25.5497 23.3482 24.8661 23.8837 24.1654 24.404C23.9625 24.5624 23.7347 24.665 23.4818 24.7117C23.1896 24.6735 22.9959 24.514 22.9008 24.2331C22.8666 23.778 22.8552 23.3223 22.8666 22.866C23.3684 22.8773 23.8697 22.866 24.3705 22.8318C24.8474 22.4333 24.8246 22.0688 24.3021 21.738C23.8242 21.7038 23.3456 21.6925 22.8666 21.7038C22.069 21.7038 21.2716 21.7038 20.474 21.7038C20.4854 20.906 20.474 20.1085 20.4398 19.3113C20.2946 17.9271 19.7136 16.765 18.6967 15.8249C18.6852 14.5943 18.6967 13.3638 18.7308 12.1335C18.9413 11.5812 19.3173 11.1824 19.8588 10.9372C23.6146 10.8242 27.3743 10.8014 31.1381 10.8689C31.8768 11.0608 32.3439 11.5279 32.5394 12.2703C32.585 14.8907 32.585 17.5112 32.5394 20.1316C32.3458 20.9633 31.8331 21.476 31.0014 21.6697C29.8798 21.682 28.7632 21.7162 27.6517 21.7722Z",
    fill: "#FEB64C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4991 12.6117C22.6159 12.6003 23.7324 12.6117 24.8487 12.6459C25.2682 12.8353 25.3935 13.1429 25.2247 13.5687C25.1345 13.7046 25.0092 13.7843 24.8487 13.808C23.7322 13.8536 22.6156 13.8536 21.4991 13.808C20.956 13.4068 20.956 13.008 21.4991 12.6117Z",
    fill: "#2E66A5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6966 15.8245C19.7135 16.7645 20.2945 17.9266 20.4397 19.3109C20.4739 20.1081 20.4853 20.9056 20.4739 21.7034C19.9658 24.5341 18.2796 26.1292 15.4153 26.4886C12.7265 26.4886 10.0377 26.4886 7.34892 26.4886C7.18779 26.4997 7.02831 26.4884 6.8704 26.4544C3.81148 25.6271 2.30757 23.6219 2.35868 20.4388C2.3449 17.2632 3.87159 15.2808 6.93876 14.4915C8.38572 14.4801 9.83262 14.4688 11.2796 14.4573C12.9107 14.4488 14.5399 14.483 16.1673 14.5599C17.1259 14.7658 17.969 15.1873 18.6966 15.8245Z",
    fill: "#9831AD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0457 15.6879C24.6207 15.6765 27.1956 15.6879 29.7703 15.7221C30.1196 15.9522 30.1993 16.2598 30.0096 16.6449C29.9295 16.7401 29.827 16.7971 29.702 16.8158C27.1499 16.8614 24.5978 16.8614 22.0457 16.8158C21.5915 16.4313 21.5915 16.0553 22.0457 15.6879Z",
    fill: "#2E66A5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28028 16.85C9.99195 16.8386 12.7036 16.85 15.415 16.8842C16.823 17.1527 17.7003 17.9845 18.0469 19.3793C18.0925 20.0856 18.0925 20.7921 18.0469 21.4984C17.776 22.977 16.8987 23.8315 15.415 24.0619C12.6807 24.1075 9.94629 24.1075 7.21192 24.0619C6.00016 23.7388 5.21403 22.9755 4.85352 21.7719C4.80794 20.906 4.80794 20.0401 4.85352 19.1742C5.23138 17.9417 6.0403 17.167 7.28028 16.85Z",
    fill: "#F1D9FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6608 18.0805C25.0079 18.069 27.3549 18.0805 29.7018 18.1146C29.9866 18.182 30.1233 18.3643 30.1119 18.6615C30.1188 18.9215 30.0049 19.1039 29.7701 19.2084C27.4003 19.254 25.0306 19.254 22.6608 19.2084C22.3115 18.9783 22.2317 18.6707 22.4215 18.2855C22.4998 18.2079 22.5795 18.1395 22.6608 18.0805Z",
    fill: "#2E66A5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55373 18.6957C7.94365 18.623 8.2285 18.7597 8.40822 19.1059C8.45382 19.6071 8.45382 20.1085 8.40822 20.6098C8.2272 21.0423 7.91959 21.1676 7.48537 20.9857C7.37948 20.9028 7.29977 20.8002 7.24611 20.6781C7.20052 20.1312 7.20052 19.5844 7.24611 19.0375C7.31618 18.888 7.41872 18.774 7.55373 18.6957Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7998 18.6957C15.1897 18.623 15.4746 18.7597 15.6543 19.1059C15.6999 19.6071 15.6999 20.1085 15.6543 20.6098C15.49 20.9825 15.2051 21.1306 14.7998 21.0541C14.6714 20.9486 14.5689 20.8233 14.4922 20.6781C14.4466 20.1312 14.4466 19.5844 14.4922 19.0375C14.5623 18.888 14.6648 18.774 14.7998 18.6957Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0144 21.0883C10.9489 21.0769 11.8831 21.0883 12.8171 21.1224C13.1866 21.2648 13.3119 21.5269 13.1931 21.9086C13.1133 22.0795 12.988 22.2048 12.8171 22.2846C11.9057 22.3302 10.9942 22.3302 10.0828 22.2846C9.47785 21.9158 9.45509 21.5169 10.0144 21.0883Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8662 21.7035C23.3453 21.6921 23.8238 21.7035 24.3018 21.7377C24.8242 22.0684 24.847 22.4329 24.3701 22.8314C23.8693 22.8656 23.368 22.8769 22.8662 22.8656C22.8662 22.4782 22.8662 22.0909 22.8662 21.7035Z",
    fill: "#CD8923"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6517 21.772C27.191 22.142 26.7125 22.4838 26.2162 22.7974C26.1277 22.7434 26.0479 22.675 25.9769 22.5923C25.8753 21.8401 26.2057 21.5438 26.9681 21.7036C27.2086 21.7038 27.4365 21.7265 27.6517 21.772Z",
    fill: "#CD8923"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    opacity: 0.998,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34859 26.4888C10.0374 26.4888 12.7262 26.4888 15.415 26.4888C15.9593 26.6003 16.4835 26.794 16.9873 27.0698C18.4181 28.1582 18.9878 29.6051 18.6962 31.4106C18.8135 33.2274 18.016 34.4123 16.3037 34.9653C16.0986 34.9653 15.8935 34.9653 15.6884 34.9653C15.6998 33.5068 15.6884 32.0485 15.6543 30.5903C15.2898 29.988 14.9024 29.9653 14.4921 30.522C14.458 32.0029 14.4465 33.4841 14.458 34.9653C12.4528 34.9653 10.4475 34.9653 8.44234 34.9653C8.45375 33.5068 8.44234 32.0485 8.40816 30.5903C8.04367 29.988 7.65634 29.9653 7.24605 30.522C7.21187 32.0029 7.20045 33.4841 7.21187 34.9653C6.98403 34.9653 6.75614 34.9653 6.52827 34.9653C4.85062 34.394 4.0531 33.209 4.1357 31.4106C4.19092 30.7551 4.2251 30.0943 4.23824 29.4282C4.69172 27.8238 5.7285 26.844 7.34859 26.4888Z",
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44276 34.9651C8.0326 34.9651 7.62245 34.9651 7.21229 34.9651C7.20087 33.4838 7.21229 32.0027 7.24647 30.5217C7.65676 29.965 8.04409 29.9878 8.40858 30.5901C8.44276 32.0483 8.45417 33.5066 8.44276 34.9651Z",
    fill: "#F1D9FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6889 34.9651C15.2787 34.9651 14.8685 34.9651 14.4584 34.9651C14.447 33.4838 14.4584 32.0027 14.4926 30.5217C14.9029 29.965 15.2902 29.9878 15.6547 30.5901C15.6889 32.0483 15.7003 33.5066 15.6889 34.9651Z",
    fill: "#F1D9FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2427_2802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0 -0.000488281)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWzchatbot);
export default __webpack_public_path__ + "static/media/Wzchatbot.85731cbca208069ee05bd948cf5ab9b9.svg";
export { ForwardRef as ReactComponent };